import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const MonitorCaseAvailabilityInfo = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      The severity trend chart shows the status of
      each run over time, allowing you to compare
      runs and observe trends.
    </Color>
  </Paragraph>

export default MonitorCaseAvailabilityInfo
